import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { MyPromise } from '../interceptors/myPromise.service';

@Injectable({
  providedIn: 'root',
})
export class NewsService {

  protected API = environment.baseEndpoint;

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise
  ) {
  }

  store(post) {
    return this.myPromise.to(this.http.post(`${this.API}/news`, post)) as any;
  }

  get() {
    return this.myPromise.to(this.http.get(`${this.API}/news`));
  }

  update(id, post) {
    return this.myPromise.to(this.http.put(`${this.API}/news/${id}`, post));
  }

  delete(id) {
    return this.myPromise.to(this.http.delete(`${this.API}/news/${id}`));
  }
}
